import React from 'react';
import { Grid2 as Grid, Paper, Typography, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { DatePicker } from '@mui/x-date-pickers';
import { Moment } from 'moment';
import FormTextField from '../../Form/FormTextField';
import {
  alpha,
  email,
  phone,
  required,
  composeValidators,
} from '../../Form/validators';
import UserEditorBase from '../UserEditorBase';

const useStyles = makeStyles((theme: Theme) => ({
  userFormSubContainer: {
    padding: theme.spacing(3),
  },
  datePicker: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
}));

const UserProfileEditor = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const formik = useFormikContext<{
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    birthDate: Moment | null;
    joinDate: Moment | null;
    designation: string;
    department: string;
  }>();

  const { values, errors, getFieldProps, setFieldValue } = formik;

  return (
    <UserEditorBase>
      <Paper>
        <div className={classes.userFormSubContainer}>
          <Typography variant="h6">{t('Basic_profile')}</Typography>
        </div>
        <Divider orientation="horizontal" />
        <div className={classes.userFormSubContainer}>
          <Grid container spacing={2}>
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-first-name-input"
              label={t('First_Name')}
              name="firstName"
              error={errors.firstName}
              variant="outlined"
              {...getFieldProps('firstName')}
              validate={composeValidators([required, alpha])}
            />
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-last-name-input"
              label={t('Last_Name')}
              name="lastName"
              error={errors.lastName}
              variant="outlined"
              {...getFieldProps('lastName')}
              validate={composeValidators([required, alpha])}
            />
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-email-input"
              label={t('Email')}
              name="email"
              error={errors.email}
              variant="outlined"
              {...getFieldProps('email')}
              validate={composeValidators([required, email])}
            />
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-phone-input"
              label={t('Phone')}
              name="phone"
              error={errors.phone}
              variant="outlined"
              {...getFieldProps('phone')}
              validate={phone}
            />
            <Grid size={{ xs: 12, md: 6 }}>
              <DatePicker
                label={t('Date_of_Birth')}
                className={classes.datePicker}
                value={values.birthDate}
                onChange={date => setFieldValue('birthDate', date)}
                format="DD/MM/YYYY"
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <DatePicker
                label={t('Joining_Date')}
                className={classes.datePicker}
                value={values.joinDate}
                onChange={date => setFieldValue('joinDate', date)}
                format="DD/MM/YYYY"
              />
            </Grid>
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-date-of-birth-input"
              label={t('Designation')}
              name="designation"
              error={errors.designation}
              variant="outlined"
              {...getFieldProps('designation')}
            />
            <FormTextField
              size={12}
              md={6}
              fullWidth
              id="user-date-of-join-input"
              label={t('Department')}
              name="department"
              error={errors.department}
              variant="outlined"
              {...getFieldProps('department')}
            />
          </Grid>
        </div>
      </Paper>
    </UserEditorBase>
  );
};

export default UserProfileEditor;
